import { useRef } from "react";
import { DynamicFormRef } from "@mavichpe/dynamic-forms";
import ShippingProviderFormConfig from "./form";
import { ShippingProviderFormData, ShippingProviderRelatedAttributes } from "@/formTypes/ShippingProviderFormDataType";
import GenericForm from "../GenericForm";
import { ShippingProviderApi, ShippingProviderDataType } from "@/api/ShippingProviderApi";
import SearchClientByIdentificationOffCanvas from "@components/layout/Offcanvas/SearchClientByIdentificationOffCanvas";
import { ClientDataType } from "@/api/ClientApi";

type ShippingProviderFormProps = {
  id?: string;
  formId: string,
  saveRedirectUrl?: string,
  onStored?: (data?: ShippingProviderDataType) => void
}

const ShippingProviderForm = (props: ShippingProviderFormProps) => {
  const formRef = useRef<DynamicFormRef>(null);

  /**
   * Siembra lo que devolvio el padron de Tributacion. Se copian solo los tres campos que
   * este modelo tiene: el offcanvas es el del catalogo de clientes y trae ademas
   * `activitycode` y `einvoice_kind`, que aqui no existen.
   */
  const onTaxpayerSelected = (taxpayer?: ClientDataType) => {
    if (!taxpayer) return;
    formRef.current?.setFormValue("multiple", {
      nombre: taxpayer.nombre,
      tipo_identificacion: taxpayer.tipo_identificacion,
      identificacion: taxpayer.identificacion,
    }, "multipleData")
  }

  return (
    <>
      <GenericForm<ShippingProviderFormData, ShippingProviderDataType>
        id={props.id}
        ref={formRef}
        formId={props.formId}
        onStored={props.onStored}
        saveRedirectUrl={props.saveRedirectUrl}
        formConfig={ShippingProviderFormConfig}
        getNextCode={() => ShippingProviderApi.getNextCode("codigo")}
        modelRelativeObjects={ShippingProviderRelatedAttributes}
        getById={(...arg) => ShippingProviderApi.get(...arg)}
        createFn={(...arg) => ShippingProviderApi.create(...arg)}
        updateFn={(...arg) => ShippingProviderApi.update(...arg)}
        successMessage="El proveedor de envio ha sido almacenado correctamente"
        errorMessage="No fue posible almacenar la información del proveedor de envio"
      />
      <SearchClientByIdentificationOffCanvas onClientSelected={onTaxpayerSelected} />
    </>
  )
}

export default ShippingProviderForm;
